import httpService from "../../services/httpService";

const bmrEditorApi = {
    getPIData: (limit, page, search, role_id, investigator_id) => httpService.get('subAdminList', {
        params: {
            limit,
            page: page,
            searchData: search,
            role_id,
            investigator_id
        }
    }),
    addEditor: (data) => httpService.post(`addSubAdmin`, data),
    editEditor: (data, id) => httpService.post(`updateSubAdmin/${id}`, data),
    deleteEditor: (id) => httpService.delete(`deleteSubAdmin/${id}`),
    subadminDropDown: () => httpService.post(`subadminDropDown/${2}`, {
        "ids": [],
    }),
    piDropDownList: () => httpService.get('assignedInvestigatorDropDown'),
    getPhaseDropDown: (user_id) => httpService.get('phaseDropDown', {
        params: {
            user_id
        }
    }),
}

export default bmrEditorApi;